import { motion } from "framer-motion";
import vrj from "../assets/vrj2.jpg";

const BioSection = () => {
  return (
    <section className="py-24 px-6 md:px-20 bg-[#F9F4EE] flex items-center justify-center overflow-hidden ">
      <div className="container mx-auto grid grid-cols-1 md:grid-cols-2 gap-16 items-center">
        {/* Organic Blob Photo Mask */}
        <motion.div
          initial={{ opacity: 0, scale: 0.8 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true }}
          className="relative flex justify-center"
        >
          <div className="w-72 h-72 md:w-96 md:h-96 bg-dreamy-gold/20 absolute -top-4 rounded-full blur-3xl" />
          <div
            className="relative w-full aspect-square max-w-md overflow-hidden bg-dreamy-earth/10 shadow-inner"
            style={{ borderRadius: "60% 40% 30% 70% / 60% 30% 70% 40%" }}
          >
            {" "}
            {/* Custom Organic Shape */}
            <img
              src={vrj}
              alt="Hasanka"
              className="w-full h-full object-cover sepia-[15%] hover:scale-105 transition-transform duration-1000"
            />
          </div>
        </motion.div>

        {/* Intro Text */}
        <div className="space-y-6">
          <h4 className="font-serif text-4xl text-dreamy-earth">In the Lens</h4>
          <p className="font-sans text-dreamy-earth/80 leading-relaxed text-lg max-w-lg">
            I’m Hasanka, a natural light photographer based in Sri Lanka. I
            believe that the most beautiful stories are told in the quiet gaps
            between poses—the wind in the hair, the soft glow of a sunset, and
            the unscripted smiles.
          </p>
          <div className="flex gap-4 items-center font-serif italic text-dreamy-earth/60">
            <span className="w-8 h-[1px] bg-dreamy-gold" />
            <span>Storyteller & Dreamer</span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BioSection;
